import { Flex } from 'shared/ui/flex';
import { BookingSlot } from './BookingSlot';
import { FC } from 'react';
import { WithPreloaderHOC } from 'shared/ui/spinner';
import { Typography } from 'shared/ui/typography';
import { useSlots } from '../../lib/hooks/useSlots';
import { useBookingTimeExpired } from '../../lib/hooks/useBookingTimeExpired';
import { ModalProvider } from 'shared/ui/modal';
import { AllSlotsModal } from 'widgets/allSlotsModal';

interface BookingSlotsListProps extends WithPreloaderHOC {
	changeSlotsLabelText: (text: string) => void;
}

export const BookingSlotsList: FC<BookingSlotsListProps> = ({
	changeSlotsLabelText,
}) => {
	const { bookingTimes, currentActive, disabledBookingTime, activeSlot } =
		useSlots();
	const { isBookingTimeExpired, formatedTime } = useBookingTimeExpired();

	if (isBookingTimeExpired()) {
		return (
			<Typography colorVariant="danger">
				Выберите актуальные дату и время, так как {formatedTime()} уже
				прошло
			</Typography>
		);
	}

	return (
		<Flex $gap="5px" $wrap="wrap">
			{bookingTimes.map(bookingTime => {
				return (
					<BookingSlot
						key={bookingTime.time}
						currentSlot={currentActive}
						disabledSlot={disabledBookingTime}
						bookingTime={bookingTime}
						activeSlot={activeSlot}
						changeSlotsLabelText={changeSlotsLabelText}
					/>
				);
			})}
      <ModalProvider>
        <AllSlotsModal 
          isBooking={true}
					currentSlot={currentActive}
					activeSlot={activeSlot}
        />
      </ModalProvider>
		</Flex>
	);
};
